<template>
  <div>
    <DynamicComponent edc-id="polaris-message-management" framework="Vue" :edc-dev="edcDev" />
  </div>
</template>

<script>
export default {
  name: 'PolarisMessageManagement',
  data() {
    return {
      edcDev: window.__EDC__.options.dev,
    }
  },
}
</script>
